import type { ActionType } from '@polyai/stream/utils/rich-text-input';

import { useEntityActionType } from 'components/molecules/LexicalEditor/features/action/components/Entity';
import { useFlowTransitionActionType } from 'components/molecules/LexicalEditor/features/action/components/FlowTransition';
import { useFunctionActionType } from 'components/molecules/LexicalEditor/features/action/components/Function';
import { useHandoffActionType } from 'components/molecules/LexicalEditor/features/action/components/Handoff';
import { useIntegrationActionType } from 'components/molecules/LexicalEditor/features/action/components/Integration';
import { useTranslationActionType } from 'components/molecules/LexicalEditor/features/action/components/Translation';
import { useTwilioSmsActionType } from 'components/molecules/LexicalEditor/features/action/components/TwilioSms';
import { useVariableActionType } from 'components/molecules/LexicalEditor/features/action/components/Variable';
import { useVariantAttributeActionType } from 'components/molecules/LexicalEditor/features/action/components/VariantAttribute';
import type {
  ActionTypeInput,
  ActionTypeOutput,
} from 'components/molecules/LexicalEditor/features/action/types';

type UseActionRendererProps = ActionTypeInput & {
  type: ActionType;
};

const actionTypeMap: Record<
  ActionType,
  (props: ActionTypeInput) => ActionTypeOutput
> = {
  function: useFunctionActionType,
  flow_transition: useFlowTransitionActionType,
  handoff: useHandoffActionType,
  twilio_sms: useTwilioSmsActionType,
  variant_attribute: useVariantAttributeActionType,
  entities: useEntityActionType,
  variable: useVariableActionType,
  integration: useIntegrationActionType,
  translation: useTranslationActionType,
};

export const useActionRenderer = ({ type, id }: UseActionRendererProps) => {
  if (!(type in actionTypeMap)) {
    return null;
  }

  return actionTypeMap[type]({ id });
};
